module.exports = __webpack_public_path__ + "09_long_black.dbf00aed.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/09_long_black.png
// module id = ZjJ1
// module chunks = 0